import { ReactComponent as Userregistration } from "../../../Assets/Images/userRegistration.svg";

import { useNavigate } from 'react-router-dom';
import { useState, useContext, useEffect } from 'react';

import { getCity, getState, getUserType, getTermsConditions, getPincodeCheck, saveUserData, getStateCity } from '../../../Services/action.js';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { DataContext } from '../../../Components/DataContext.js';
import { regex } from '../../../utils/constants';
import AppTracking from "../../../Components/appTracking.js";

const UserRegistrationPage = () => {



  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalWarning, setIsModalWarning] = useState(false);
  const [termsModal, setTermsModal] = useState(false);
  const [termsData, setTermsData] = useState('');
  const [modal, setModal] = useState('');
  const { data, setData } = useContext(DataContext);
  const newData = { ...data };
  const userStatus = newData.userType;
  const mobileNum = newData.mobileNumber;
  const [name, setName] = useState('');
  const [resultName, setResultName] = useState(false);
  const [nameError, setNameError] = useState('');
  const [pincode, setPincode] = useState('');
  const [resultPincode, setResultPincode] = useState(false);
  const [pincodeError, setPincodeError] = useState('');
  const [latLong, setLatLong] = useState(true);
  const [stateName, setStateName] = useState('');
  const [stateId, setStateId] = useState(0);
  const [cityName, setCityName] = useState('');
  const [cityId, setCityId] = useState(0);
  const [loader, setLoader] = useState(false);
  const [userTypeId, setUserTypeId] = useState(0);
  const [terms, setTerms] = useState(false);

  const handleChangeName = (event) => {
    setName(event.target.value.replace(/[^a-zA-Z\s]/g, '').trimStart());
    let pattern = regex.nameRegex;
    let resName = pattern.test(event.target.value.replace(/[^a-zA-Z\s]/g, '').trimStart());
    setResultName(resName);
    if (!resName || event.target.value.replace(/[^a-zA-Z\s]/g, '') === '') {
      setNameError("Please enter valid name");
    }
  }

  const handleChangePincode = (event) => {
    setPincode(event.target.value.replace(/\D/g, ''));
    let pattern = regex.pinRegex;
    let resPincode = pattern.test(event.target.value.replace(/\D/g, ''));
    setResultPincode(resPincode);
    if (!resPincode) {
      setPincodeError("Please enter valid PIN code")
    }
    else {
      if (event.target.value.replace(/\D/g, '').length == 6)
        setLoader(true);
      getPincodeCheck(event.target.value.replace(/\D/g, ''))
        .then((data) => {
          setLoader(false);
          if (data[0].PostOffice == null) {
            setResultPincode(false);
          }
          else {
            setResultPincode(true);
          }
        })
    }
  }


  const getLatLong = (event, stateData) => {
    setLatLong(event);
    if (event) {
      setLoader(true);
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        console.log('result', result.state);
        if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition(function (position) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            getStateCity({
              "latitude": String(latitude),
              "longitude": String(longitude),
              "mobileNo": newData.mobileNumber
            }, newData.tokenData)
              .then((data) => {
                let latLongDetails = data.data;
                setStateName(latLongDetails.state);
                setPincode(latLongDetails.pin);
                setResultPincode(true);
                let selected = stateData.findIndex(
                  (element) => element.objectName === latLongDetails.state
                );
                setStateId(stateData[selected].objectID);
                getCity({
                  mobileNo: mobileNum,
                  locationType: 'city',
                  parentStateId: stateData[selected].objectID
                })
                  .then((data) => {
                    let obj = {
                      objectID: 0,
                      objectName: "Select City",
                      objectCode: "JCB"
                    };
                    data.data.objectDetails.unshift(obj);
                    setCityList(data.data.objectDetails);
                    let select = data.data.objectDetails.findIndex(
                      (element) => element.objectName === latLongDetails.city
                    );
                    setCityId(data.data.objectDetails[select].objectID);
                    setCityName(latLongDetails.city);
                    setLoader(false);
                  })
                  .catch((error) => {
                    setLoader(false);
                  });
              })
              .catch((error) => {
                setStateName('');
                setStateId(0);
                setCityName('');
                setCityId(0);
                setPincode('');
                setLoader(false);
              });
          })
        }
        else if (result.state === 'denied') {
          setLoader(false);
        }
        else if (result.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(function (position) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            getStateCity({
              "latitude": String(latitude),
              "longitude": String(longitude),
              "mobileNo": newData.mobileNumber
            }, newData.tokenData)
              .then((data) => {
                let latLongDetails = data.data;
                setStateName(latLongDetails.state);
                setPincode(latLongDetails.pin);
                setResultPincode(true);
                let selected = stateData.findIndex(
                  (element) => element.objectName === latLongDetails.state
                );
                setStateId(stateData[selected].objectID);
                getCity({
                  mobileNo: mobileNum,
                  locationType: 'city',
                  parentStateId: stateData[selected].objectID
                })
                  .then((data) => {
                    let obj = {
                      objectID: 0,
                      objectName: "Select City",
                      objectCode: "JCB"
                    };
                    data.data.objectDetails.unshift(obj);
                    setCityList(data.data.objectDetails);
                    let select = data.data.objectDetails.findIndex(
                      (element) => element.objectName === latLongDetails.city
                    );
                    setCityId(data.data.objectDetails[select].objectID);
                    setCityName(latLongDetails.city);
                    setLoader(false);
                  })
                  .catch((error) => {
                    setLoader(false);
                  });
              })
              .catch((error) => {
                setStateName('');
                setStateId(0);
                setCityName('');
                setCityId(0);
                setPincode('');
                setLoader(false);
              });
          })

        }
      })


    }
    else {
      setStateName('');
      setCityName('');
      setPincode('');
    }
  }
  const navigate = useNavigate();
  useEffect(() => {
    if (newData.couponCode == null) {
      navigate('/');
    }

    newData.registration = true;
    setData(newData);
    setLoader(true);
    getUserType({
      mobileNo: mobileNum,
      locationType: 'user_type',
      parentStateId: '0',
    })
      .then((data) => {
        let obj = {
          objectID: 0,
          objectName: "Select User Type",
          objectCode: "Select User Type"
        };
        data.data.objectDetails.unshift(obj);
        setUserTypeList(data.data.objectDetails);
        getState({ mobileNum, locationType: 'state', parentStateId: '0' })
          .then((data) => {
            let obj = {
              objectID: 0,
              objectName: "Select State",
              objectCode: "JCB"
            };
            data.data.objectDetails.unshift(obj);
            setStateList(data.data.objectDetails);
            setLoader(false);
            console.log("1");
            getLatLong(true, data.data.objectDetails);

            openTerms();
          })
          .catch((error) => {
            setLoader(false);
          });
      })
      .catch((error) => {
        setLoader(false);
      });
  }, []);
  const onStateChange = (event) => {
    setLoader(true);
    setCityId(0);
    setStateName(event.target.value);
    let selected = stateList.findIndex(
      (element) => element.objectName === event.target.value
    );
    setStateId(stateList[selected].objectID);
    getCity({
      mobileNo: mobileNum,
      locationType: 'city',
      parentStateId: stateList[selected].objectID
    })
      .then((data) => {
        setLoader(false);
        let obj = {
          objectID: 0,
          objectName: "Select City",
          objectCode: "JCB"
        };
        data.data.objectDetails.unshift(obj);


        setCityList(data.data.objectDetails);

      })
      .catch((error) => {
        setLoader(false);
      });
  };

  const onCityChange = (event) => {
    setCityName(event.target.value);
    let selected = cityList.findIndex(
      (element) => element.objectName === event.target.value
    );
    setCityId(cityList[selected].objectID);
  };
  const handleChangeUserType = (event) => {
    setUserTypeId(event.target.value)
  };
  const handleClose = (type) => {
    if (type === 1) {
      setIsModalSuccess(false);
      newData.registration = false;
      setData(newData);
      navigate('/dashboard')
    }
    else if (type === 2) {
      setIsModalError(false);
    }
    else if (type === 3) {
      setIsModalWarning(false);
    }
    else if (type === 5) {
      setTerms(true);
      setTermsModal(false);
    }
    else if (type === 6) {
      setTermsModal(false);
    }
  }
  const onSubmit = () => {
    setLoader(true);
    newData.token = newData.tokenData;
    setData(newData);


    saveUserData({
      mobileNo: mobileNum,
      name: name.trimEnd(),
      stateId: stateId,
      cityId: cityId,
      pincode: pincode,
      saveType: userStatus,
      userType: userTypeId,
    }, newData.token)
      .then((data) => {
        if (data.status.status === 'Y' && data.statusMsg.code === 0) {
          setLoader(false);
          setModal(data.statusMsg.msg)
          setIsModalSuccess(true);
        } else if (data.status.status === 'N' && data.statusMsg.code === 1) {
          setLoader(false);
          setModal(data.statusMsg.msg);
          setIsModalWarning(true);
        } else if (data.status.status === 'N' && data.statusMsg.code === -1) {
          setLoader(false);
          setModal(data.statusMsg.msg);
          setIsModalError(true);
        }
      })
      .catch((error) => {
      });
  };
  const openTerms = () => {
    setLoader(true);
    getTermsConditions(mobileNum, newData.tokenData)
      .then((data) => {
        setLoader(false);
        setTermsModal(true);
        setTermsData(data.data.desc);
      })
      .catch((error) => {
      });

  }
  return (
    <>
      <AppTracking pageName={window.location.pathname.replace(/\//g, '')} />
      <div className='content-wrapper responsive-wrapper'>
        <div className='row'>
          <div className='col-lg-4 col-md-4 col-sm-12 m-auto'>
            <div className='DarkPanel'>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <Userregistration />
              </div>
            </div>
            <section className='FormPanel pt-3'>
              <h3>User Details</h3>
              <div className='row'>
                <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>

                  <input
                    id='phoneNumber'
                    name='phoneNumber'
                    type='text'
                    className='form-control disabled'
                    placeholder='Enter Mobile Number'
                    defaultValue={mobileNum}
                    disabled
                  />

                </div>
                <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>

                  <input
                    type='text'
                    className='form-control'
                    placeholder='Enter Name'
                    id='userName'
                    name='userName'
                    maxLength={50}
                    value={name}
                    onChange={(event) => handleChangeName(event)}
                  />
                  {!resultName ? (
                    <div className='error text-danger text-start'>
                      {nameError}
                    </div>
                  ) : null}
                </div>
                <div className='col-lg-12 col-md-12 col-sm-12 mb-3'>
                  <select
                    className='form-select form-select'
                    aria-label='.form-select example'
                    id='user_type'
                    name='user_type'
                    onChange={(event) => handleChangeUserType(event)}
                    value={userTypeId}
                  >
                    {userTypeList?.map((field, i) => (
                      <option value={field?.objectID} key={i}>
                        {field?.objectName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12 ps-3'>
                  <div className='form-check text-start mx-4 mt-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={latLong}
                      onChange={(e) => { getLatLong(e.target.checked, stateList) }}

                    />
                    <label className='form-check-label'>
                      Allow location service
                    </label>
                  </div>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12 mt-n10'>
                  <div className='whitePanel mb-2'>
                    <div className='row'>
                      <div className='col-sm-12 mb-2'>
                        <select
                          className='form-select form-select'
                          aria-label='.form-select example'
                          id='state'
                          name='state'
                          onChange={(e) => { onStateChange(e) }}
                          value={stateName}
                        >

                          {stateList?.map((field, i) => (
                            <option value={field?.objectName} key={i}>
                              {field?.objectName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 mb-2'>
                        <select
                          className='form-select form-select'
                          aria-label='.form-select example'
                          id='city'
                          name='city'
                          disabled={cityList.length === 0}
                          onChange={(e) => { onCityChange(e) }}
                          value={cityName}
                        >

                          {cityList?.map((field, i) => (
                            <option value={field?.objectName} key={i}>
                              {field?.objectName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className=''>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Enter Pincode'
                            id='pinCode'
                            name='pinCode'
                            maxLength={6}
                            inputMode="numeric"
                            value={pincode}
                            onChange={(event) => handleChangePincode(event)}
                          />
                          {!resultPincode ? (
                            <div className='error text-danger text-start'>
                              {pincodeError}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='terms text-center pt-1'>
                    <p>
                      <a onClick={openTerms} ><u>Terms & Conditions</u></a>
                    </p>
                    {/* {!terms ? (
                      <div className='error text-start'>
                        Terms & Conditions must be accepted
                      </div>
                    ) : null} */}
                  </div>
                </div>
              </div>
              <div className='row mt-1'>
                <div className='col-lg-12 col-md-12 col-sm-12 mb-3 '>
                  <button
                    type='submit'
                    className='btn btn-primary'
                    disabled={!resultName || name == '' || !resultPincode || userTypeId == 0 || stateId == 0 || cityId == 0 || !terms}
                    onClick={onSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
              {/* </form> */}
            </section>
          </div>
        </div>
      </div>



      <Modal show={termsModal} backdrop="static" keyboard={false} onHide={() => handleClose(5)}>
        <Modal.Header>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body dangerouslySetInnerHTML={{ __html: termsData }}>

        </Modal.Body>
        <Modal.Footer>
          {terms ? (
            <Button variant="secondary" onClick={() => handleClose(6)}>
              Close
            </Button>
          ) : <Button className='btn-green' onClick={() => handleClose(5)}>
            Accept
          </Button>}
        </Modal.Footer>
      </Modal>

      <Modal className="success" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalSuccess} onHide={() => handleClose(1)} >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/accept.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(1)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="error" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalError} onHide={() => handleClose(2)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/cross.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(2)}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal >
      <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalWarning} onHide={() => handleClose(3)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(3)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {loader && (
        <div id="overlay">
          <span className="loader"></span>
        </div>
      )}
    </>
  );
};

export default UserRegistrationPage;
